export default {
  "component.tagSelect.expand": "Expand",
  "component.tagSelect.collapse": "Collapse",
  "component.tagSelect.all": "All",
  "component.AudioUploader.index.t0": "Uploading",
  "component.AudioUploader.index.t1": "Upload",
  "component.AudioUploader.index.t2": "If the request failed, please try it later",
  "component.AutoUploader.index.t0": "Upload image",
  "component.AutoUploader.index.t1": "If the request failed, please try it later",
  "component.AutoUploader.index.t2": "No picture",
  "component.DetectItem.index.t0": "Systolic Blood Pressure",
  "component.DetectItem.index.t1": "Diastolic Blood Pressure",
  "component.DetectItem.index.t2": "Heart Rate",
  "component.DetectItem.index.t3": "Blood Sugar",
  "component.DetectItem.index.t4": "Blood Oxygen",
  "component.DetectItem.index.t5": "Body Temperature",
  "component.DetectItem.index.t6": "None",
  "component.DoubleCallModal.index.t0": "Call successful",
  "component.DoubleCallModal.index.t1": "Call failure",
  "component.DoubleCallModal.index.t2": "Dial number",
  "component.DoubleCallModal.index.t3": "Customer phone",
  "component.DoubleCallModal.index.t4": "Please enter the customer phone number",
  "component.DoubleCallModal.index.t5": "My phone",
  "component.DoubleCallModal.index.t6": "Please enter your phone number",
  "component.DraggableModal.index.t0": "Hint",
  "component.Editor.index.t0": "The picture upload failed, please try again later",
  "component.Exception.index.t0": "Sorry, the page you visit does not exist",
  "component.Exception.index.t1": "Return homepage",
  "component.Exception.index.t2": "Sorry, you have no right to visit this page",
  "component.Exception.index.t3": "Return homepage",
  "component.Footer.index.t0": "Lanxi Health Management Co., Ltd.",
  "component.Form.CreateForm.t0": "New rules",
  "component.Form.UpdateForm.t0": "Monitoring object",
  "component.Form.UpdateForm.t1": "Table I",
  "component.Form.UpdateForm.t2": "Table II",
  "component.Form.UpdateForm.t3": "Regular template",
  "component.Form.UpdateForm.t4": "Rules Template",
  "component.Form.UpdateForm.t5": "Rules Template 2",
  "component.Form.UpdateForm.t6": "Rules",
  "component.Form.UpdateForm.t7": "Powerful",
  "component.Form.UpdateForm.t8": "Weak",
  "component.Form.UpdateForm.t9": "Start Time",
  "component.Form.UpdateForm.t10": "Please choose the start time!",
  "component.Form.UpdateForm.t11": "Choose start time",
  "component.Form.UpdateForm.t12": "Scheduling cycle",
  "component.Form.UpdateForm.t13": "Moon",
  "component.Form.UpdateForm.t14": "Week",
  "component.Form.UpdateForm.t15": "Rule name",
  "component.Form.UpdateForm.t16": "Please enter the rules name!",
  "component.Form.UpdateForm.t17": "Please enter",
  "component.Form.UpdateForm.t18": "Rule description",
  "component.Form.UpdateForm.t19": "Please enter the rules of at least five characters!",
  "component.Form.UpdateForm.t20": "Please enter at least five characters",
  "component.Form.UpdateForm.t21": "Back",
  "component.Form.UpdateForm.t22": "Cancel",
  "component.Form.UpdateForm.t23": "Next",
  "component.Form.UpdateForm.t24": "Back",
  "component.Form.UpdateForm.t25": "Cancel",
  "component.Form.UpdateForm.t26": "Finish",
  "component.Form.UpdateForm.t27": "Cancel",
  "component.Form.UpdateForm.t28": "Next ",
  "component.Form.UpdateForm.t29": "Regular configuration",
  "component.Form.UpdateForm.t30": "Basic Information",
  "component.Form.UpdateForm.t31": "Configuration rules attribute",
  "component.Form.UpdateForm.t32": "Set the scheduling cycle",
  "component.HeaderContent.index.t0": "Refresh the current page",
  "component.HeaderContent.index.t1": "Turn off the current tag",
  "component.HeaderContent.index.t2": "Turn off the right side",
  "component.HeaderContent.index.t3": "Close the left side",
  "component.HeaderContent.index.t4": "Close all",
  "component.HeaderContent.index.t5": "Unable to be closed",
  "component.HeaderContent.index.t6": "There is no label on the right",
  "component.HeaderContent.index.t7": "There is no label on the left",
  "component.Inquiry.InquiryCountdown.t0": "Inquiries",
  "component.Inquiry.InquiryCountdown.t1": "Minute",
  "component.Inquiry.InquiryCountdown.t2": "Second",
  "component.Inquiry.InquiryCountdown.t3": "After consultation",
  "component.Inquiry.InquiryDropdown.t0": "Set",
  "component.Inquiry.InquiryDropdown.t1": "Line",
  "component.Inquiry.InquiryDropdown.t2": "Online",
  "component.Inquiry.InquiryDropdown.t3": "Enquiry Desk",
  "component.Inquiry.InquiryDropdown.t4": "Check the customer's online consultation message and reply to the customer in time",
  "component.Inquiry.InquiryDropdown.t5": "Connect",
  "component.Inquiry.InquiryDropdown.t6": "Enquiry Desk",
  "component.Inquiry.InquiryHeader.t0": " Customer Information",
  "component.Inquiry.InquiryHeader.t1": "Age:",
  "component.Inquiry.InquiryHeader.t2": "Age",
  "component.Inquiry.InquiryHeader.t3": "Gender:",
  "component.Inquiry.InquiryHeader.t4": "Phone number:",
  "component.Inquiry.InquiryList.t0": "Picture",
  "component.Inquiry.InquiryList.t1": "Voice",
  "component.Inquiry.InquiryList.t2": "Unknown message type",
  "component.Inquiry.InquiryList.t3": "Dialogue History",
  "component.Inquiry.InquiryList.t4": "Be visited",
  "component.Inquiry.InquiryList.t5": "Be visited",
  "component.Inquiry.InquiryMessage.t0": "Chat picture",
  "component.Inquiry.InquiryMessage.t1": "Your browser does not support audio playback, it is recommended that you use Google browser",
  "component.Inquiry.InquiryMessage.t2": "Unknown message category",
  "component.Inquiry.InquiryRecordList.t0": "I",
  "component.Inquiry.InquirySender.t0": "Please enter the content",
  "component.Inquiry.InquirySender.t1": "End consultation",
  "component.Inquiry.InquirySender.t2": "Is the time before the time arrives?",
  "component.Inquiry.InquirySender.t3": "Enter send, shift+Enter to change the line",
  "component.Maps.TMap.t0": "Address:",
  "component.Maps.TMap.t1": "Address:",
  "component.Maps.TMap.t2": "Please Enter",
  "component.Maps.TMap.t3": "Total {TOTAL}",
  "component.Maps.TMap.t4": "Expand",
  "component.Maps.TMap.t5": "Collapse",
  "component.Maps.TMap.t6": "Address:",
  "component.MessageCenter.index.t0": " All",
  "component.MessageCenter.index.t1": "Announcement",
  "component.MessageCenter.index.t2": "Notice",
  "component.MessageCenter.index.t3": "Notice",
  "component.MessageCenter.index.t4": "Announcement",
  "component.MessageCenter.index.t5": "Task creation notice",
  "component.MessageCenter.index.t6": "Task completion notice",
  "component.MessageCenter.index.t7": "Taste shutdown notice",
  "component.MessageCenter.index.t8": "Task Modification Notice",
  "component.MessageCenter.index.t9": "Task transfer notice",
  "component.MessageCenter.index.t10": "Task processing notice",
  "component.MessageCenter.index.t11": "New customer reminder",
  "component.MessageCenter.index.t12": "Task Reminder",
  "component.MessageCenter.index.t13": "All",
  "component.MessageCenter.index.t14": " All",
  "component.MessageCenter.index.t15": "Delete",
  "component.MessageCenter.index.t16": "Confirm that the message is deleted?",
  "component.MessageCenter.index.t17": "Delete",
  "component.MessageCenter.index.t18": "Confirm that all read messages are deleted?",
  "component.MessageCenter.index.t19": "Hint",
  "component.MessageCenter.index.t20": "Do you confirm that all messages are read to read?",
  "component.MessageCenter.index.t21": "Check all messages",
  "component.MessageCenter.index.t22": "Just look at the unreasonable news",
  "component.MessageCenter.index.t23": "Mark all read",
  "component.MessageCenter.index.t24": "Delete all read messages",
  "component.MessageCenter.index.t25": "Summary",
  "component.MessageCenter.index.t26": "Service Item",
  "component.MessageCenter.index.t27": "Sources of mission",
  "component.MessageCenter.index.t28": "Task Creator：Individual、Team",
  "component.MessageCenter.index.t29": "Mission transfer",
  "component.MessageCenter.index.t30": "Executed By",
  "component.MessageCenter.index.t31": "Actual execution time",
  "component.MessageCenter.index.t32": "Executed By",
  "component.MessageCenter.index.t33": "Plan execution time",
  "component.MessageCenter.index.t34": "Description ",
  "component.MessageCenter.index.t35": "Check more details",
  "component.MessageCenter.index.t36": "Check all the information and deal with the task in time",
  "component.MessageCenter.index.t37": "Message Center",
  "component.MessageCenter.index.t38": " All",
  "component.MessageCenter.index.t39": "All",
  "component.MessageCenter.index.t40": "Announcement",
  "component.MessageCenter.index.t41": "Announcement",
  "component.MessageCenter.index.t42": "Announcement",
  "component.MessageCenter.index.t43": "Notice",
  "component.MessageCenter.index.t44": "Notice",
  "component.MessageCenter.index.t45": "Notice",
  "component.MessageCenter.index.t46": "Notice",
  "component.NoticeIcon.index.t0": "Cleared",
  "component.NoticeIcon.index.t1": "Empty",
  "component.NoticeIcon.index.t2": "See more",
  "component.NoticeIcon.index.t3": "Notice",
  "component.NoticeIcon.index.t4": "You have checked all notifications",
  "component.NoticeIcon.index.t5": "Information",
  "component.NoticeIcon.index.t6": "You have read all messages",
  "component.NoticeIcon.index.t7": "Upcoming",
  "component.NoticeIcon.index.t8": "You have finished all to do",
  "component.RightContent.AvatarDropdown.t0": "Editing information",
  "component.RightContent.AvatarDropdown.t1": "Change Password",
  "component.RightContent.AvatarDropdown.t2": "Personal center",
  "component.RightContent.AvatarDropdown.t3": "Personal settings",
  "component.RightContent.AvatarDropdown.t4": "Sign out",
  "component.GlobalHeaderRight.index.t0": "Updating",
  "component.GlobalHeaderRight.index.t1": "Renew the user information failure, please try it out!",
  "component.GlobalHeaderRight.index.t2": "Be setting up",
  "component.GlobalHeaderRight.index.t3": "Successfully set",
  "component.GlobalHeaderRight.index.t4": "Set up failure, please try it out!",
  "component.GlobalHeaderRight.index.t5": "Check the help document, and quickly be familiar with the system",
  "component.GlobalHeaderRight.index.t6": "Help Manual",
  "component.GlobalHeaderRight.index.t7": "Modify Personal Information",
  "component.GlobalHeaderRight.index.t8": "Uploading",
  "component.GlobalHeaderRight.index.t9": "Successfully upload",
  "component.GlobalHeaderRight.index.t10": "Upload failed, please try again later",
  "component.GlobalHeaderRight.index.t11": "Staff Name",
  "component.GlobalHeaderRight.index.t12": "Please type in your name!",
  "component.GlobalHeaderRight.index.t13": "Registered User Name",
  "component.GlobalHeaderRight.index.t14": "Please enter your login name!",
  "component.GlobalHeaderRight.index.t15": "Contact Number",
  "component.GlobalHeaderRight.index.t16": "Please enter the right mobile phone / fixed -line number!",
  "component.GlobalHeaderRight.index.t17": "Change the avatar",
  "component.GlobalHeaderRight.index.t18": "Upload Photos",
  "component.GlobalHeaderRight.index.t19": "Change Password",
  "component.GlobalHeaderRight.index.t20": "Please set the correct password format!",
  "component.GlobalHeaderRight.index.t21": "Please enter a new password!",
  "component.GlobalHeaderRight.index.t22": "Please enter a new password!",
  "component.GlobalHeaderRight.index.t23": "Note: The password length needs to be greater than 6 digits (including). It supports input letters, numbers and characters, and must include more than 2 items. After the setting is successful, you need to log in again.",
  "component.GlobalHeaderRight.index.t24": "Modify information",
  "component.GlobalHeaderRight.index.t25": "Sign out",
  "component.GlobalHeaderRight.index.t26": "Save",
  "component.GlobalHeaderRight.index.t27": "Failure to modify, please try again later",
  "component.GlobalHeaderRight.index.t28": "Failure to modify, please try again later",
  "component.GlobalHeaderRight.index.t29": "Contact Number",
  "component.GlobalHeaderRight.index.t30": "Please enter phone number",
  "component.GlobalHeaderRight.index.t31": "Please enter the right mobile phone/fixed -line number!",
  "component.GlobalHeaderRight.index.t32": "Verification code",
  "component.GlobalHeaderRight.index.t33": "Verification code",
  "component.GlobalHeaderRight.index.t34": "Get verification code",
  "component.GlobalHeaderRight.index.t35": "Get verification code",
  "component.GlobalHeaderRight.index.t36": "Please enter verification code!",
  "component.GlobalHeaderRight.index.t37": "Get the verification code successfully!",
  "component.GlobalHeaderRight.index.t38": "Get the verification code failed, please try again later",
  "component.GlobalHeaderRight.index.t39": "Get the verification code failed, please try again later",
  "component.GlobalHeaderRight.index.t40": "New password",
  "component.GlobalHeaderRight.index.t41": "Please enter a new password",
  "component.GlobalHeaderRight.index.t42": "Please set the correct password format!",
  "component.GlobalHeaderRight.index.t43": "Note: The password length needs to be greater than 6 digits (including). It supports input letters, numbers and characters, and must include more than 2 items. After the setting is successful, you need to log in again.",
  "component.GlobalHeaderRight.index.t44": "Please enter correct contact number",
  "component.GlobalHeaderRight.index.t45": "For example, 01088888888, there is no punctuation symbol connection in the middle.",
  "component.GlobalHeaderRight.index.t46": "Please enter",
  "component.GlobalHeaderRight.index.t47": "Please enter correct contact number",
  "component.GlobalHeaderRight.index.t48": "Two passwords are different",
  'component.GlobalHeaderRight.index.t49': 'Old Password',
  'component.GlobalHeaderRight.index.t50': 'New Password',
  'component.GlobalHeaderRight.index.t51': 'Enter Again',
  'component.GlobalHeaderRight.index.t52': 'Please obtain the verification code',
  "component.RightContent.MessageNotice.t0": "Check",
  "component.RightContent.MessageNotice.t1": "New task reminder",
  "component.RightContent.MessageNotice.t2": "You receive a new task, click to view it",
  "component.RightContent.MenuSearch.t0": "Site search",
  "component.Uploader.index.t0": "Upload",
  "component.Uploader.index.t1": "Upload failed",
  "component.VideoUploader.index.t0": "Please upload the video",
  "component.VideoUploader.index.t1": "Video is being uploaded",
  "component.VideoUploader.index.t2": "Upload",
  "component.VideoUploader.index.t3": "Support only MP4 format.",
  "components.LocaleModifyComp.index.t0": "Modify i18n Configuration",
  "components.LocaleModifyComp.index.t1": "Confirm the changes?",
  "components.LocaleModifyComp.index.t2": "Sort",
  "components.LocaleModifyComp.index.t3": "Before Modification",
  "components.LocaleModifyComp.index.t4": "After Modification",
  "components.LocaleModifyComp.index.t5": "The input field cannot be empty!",
  "components.LocaleModifyComp.index.t6": "Enter keywords to search",
};
